import http from '@/lib/http'
import type { GP } from '@/types/gp'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

export const useGetGPs = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery<GP[]>({
    queryKey: ['gps'],
    queryFn: () => http.get('/gp-details'),
    enabled
  })
}

export type UpdateGPBody = Partial<
  Pick<
    GP,
    | 'name'
    | 'contact_number'
    | 'address_line_1'
    | 'address_line_2'
    | 'address_line_3'
    | 'address_line_4'
    | 'postcode'
    | 'county'
    | 'email'
  >
>

export const useUpdateGPMutation = (hash: string) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (body: UpdateGPBody) => http.patch(`/gp-details/${hash}`, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gps'] })
    }
  })
}
